import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import Circoli from "@/pages/Circoli";
import Galleria from "@/pages/Galleria";
import Modulistica from "@/pages/Modulistica";
import RassegnaStampa from "@/pages/RassegnaStampa";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/circoli" element={<Circoli />} />
          <Route path="/galleria" element={<Galleria />} />
          <Route path="/modulistica" element={<Modulistica />} />
          <Route path="/rassegna-stampa" element={<RassegnaStampa />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="light" position="top-center" />
    </div>
  );
}

export default App;
